import { render, staticRenderFns } from "./BioprocessingProduction.vue?vue&type=template&id=2dde09df&scoped=true&"
var script = {}
import style0 from "./BioprocessingProduction.vue?vue&type=style&index=0&id=2dde09df&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dde09df",
  null
  
)

export default component.exports